import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";
import {Observable} from "rxjs";
import {CrystalclearBillingBackUrl} from "../config/crystalclear-billing-back-url";
import {InvoiceLoadRequest} from "../../model/billing/invoice-load-request";
import {Invoice} from "../../model/billing/invoice";
import {Order} from "../../model/clearing/order";
import {InvoiceDetailLoadRequest} from "../../model/billing/invoice-detail-load-request";
import {InvoiceOrdersChangeRequest} from "../../model/billing/invocie-order-change-request";

@Injectable({
  providedIn: 'root'
})
export class BillingService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public list(request: InvoiceLoadRequest): Observable<TableRecordResult<Invoice>> {
    return this.post(CrystalclearBillingBackUrl.GET_BILLING_LIST, request);
  }
  public listDetail(request: InvoiceDetailLoadRequest): Observable<TableRecordResult<Order>> {
    return this.post(CrystalclearBillingBackUrl.GET_BILLING_LIST_DETAILS, request);
  }
  public generateInvoice(request: Invoice): Observable<ApiValidation<Invoice>> {
    return this.post(CrystalclearBillingBackUrl.GET_BILLING_GENERATE, request);
  }
  public cancelInvoice(request: Invoice): Observable<ApiValidation<Invoice>> {
    return this.post(CrystalclearBillingBackUrl.GET_BILLING_CANCEL, request);
  }
  public payInvoice(request: Invoice): Observable<ApiValidation<Invoice>> {
    return this.post(CrystalclearBillingBackUrl.GET_BILLING_PAY, request);
  }
  public updateOutstandingAmount(invoice: Invoice): Observable<ApiValidation<any>> {
    return this.post(CrystalclearBillingBackUrl.POST_BILLING_UPDATE_OUTSTANDING, invoice);
  }
  public saveOrders(request: InvoiceOrdersChangeRequest): Observable<ApiValidation<any>> {
    return this.post(CrystalclearBillingBackUrl.GET_BILLING_SAVE_ORDERS, request);
  }
}
